import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 col-12 mx-auto policy-content">
            <h1>Privacy Policy for Curenza</h1>
            <p>
              Omshakthi Monitoring Service (“OMS”, “we”, “us”) respects your
              privacy and is committed to protecting your personal data under
              the Information Technology Act, 2000 and applicable rules.
            </p>
            <p>
              <strong>Effective Date :</strong> 30 May 2025
            </p>
            <div className="content">
              <section>
                <h2>1. Information We Collect</h2>
                <ul>
                  <li>Full name, phone number, address</li>
                  <li>Email ID (if provided)</li>
                  <li>Booking/service history</li>
                </ul>
              </section>

              <section>
                <h2>2. Purpose of Collection</h2>
                <p>This information is collected to:</p>
                <ul>
                  <li>Facilitate service bookings</li>
                  <li>Assign vendors</li>
                  <li>Provide customer support</li>
                  <li>Send service updates or confirmations</li>
                </ul>
              </section>

              <section>
                <h2>3. Data Sharing</h2>
                <p>
                  We share personal data only with assigned vendors to fulfill
                  confirmed bookings. We do not sell, rent, or disclose your
                  data for advertising.
                </p>
              </section>

              <section>
                <h2>4. Payment Security</h2>
                <p>
                  All transactions are processed via Razorpay. OMS does not
                  store payment card or banking information.
                </p>
              </section>

              <section>
                <h2>5. Data Retention</h2>
                <p>
                  We retain user data for as long as necessary to provide
                  services or comply with legal requirements.
                </p>
              </section>

              <section>
                <h2>6. Your Rights</h2>
                <p>
                  You have the right to access, update, or delete your personal
                  data. Requests can be made via{" "}
                  <Link to={"mailto:omsprivateltd@gmail.com"}>
                    omsprivateltd@gmail.com
                  </Link>
                  .
                </p>
              </section>

              <section>
                <h2>7. Security</h2>
                <p>
                  We implement reasonable safeguards including encryption and
                  access control to protect your data.
                </p>
              </section>

              <section>
                <h2>8. Changes to This Policy</h2>
                <p>
                  OMS may update this policy. Continued use of the platform
                  implies acceptance of the updated privacy terms.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
